module.exports = __webpack_public_path__ + "4678ca6a7935975c6820623ea93a7cec.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-16.cur
// module id = 444
// module chunks = 0